import { render, staticRenderFns } from "./workShift-add-or-update.vue?vue&type=template&id=c3110912&scoped=true"
import script from "./workShift-add-or-update.vue?vue&type=script&lang=js"
export * from "./workShift-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./workShift-add-or-update.vue?vue&type=style&index=0&id=c3110912&prod&scoped=true&lang=css"
import style1 from "./workShift-add-or-update.vue?vue&type=style&index=1&id=c3110912&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3110912",
  null
  
)

export default component.exports